import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../helpers/export'
import { groupDataByOrgId } from '../relatedCompany/helpers'
import CategoryService from './CategoryService'
import OwnershipAndGroupService from './OwnershipAndGroupService'

export const getHighlights = createAsyncThunk(
  'companyAnalysis/ownershipAndGroup/getHighlights',
  async (params, { rejectWithValue }) => {
    try {
      const res = await OwnershipAndGroupService.getHighlights(params)

      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const getOwnershipDetail = createAsyncThunk(
  'companyAnalysis/ownershipAndGroup/getOwnershipDetail',
  async (params, { rejectWithValue }) => {
    try {
      const res = await OwnershipAndGroupService.getOwnershipDetail(params)

      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const getOwnershipHistorical = createAsyncThunk(
  'companyAnalysis/ownershipAndGroup/getOwnershipHistorical',
  async (params, { rejectWithValue }) => {
    try {
      const res = await OwnershipAndGroupService.getOwnershipHistorical(params)
      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const getRelatedCompanyViewBy = createAsyncThunk(
  'companyAnalysis/ownershipAndGroup/getRelatedCompanyViewBy',
  async (params, { rejectWithValue }) => {
    try {
      const res = await OwnershipAndGroupService.getRelatedCompanyViewBy(params)

      return res.success
        ? groupDataByOrgId(res.data)
        : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const downloadStructureMajorShareholder = createAsyncThunk(
  'companyAnalysis/ownershipAndGroup/downloadStructureMajorShareholder',
  async (params) => {
    try {
      const res =
        await OwnershipAndGroupService.downloadStructureMajorShareholder(params)
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)

export const downloadParentCompany = createAsyncThunk(
  'companyAnalysis/ownershipAndGroup/downloadParentCompany',
  async (params) => {
    try {
      const res = await OwnershipAndGroupService.downloadParentCompany(params)
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)

export const downloadBranch = createAsyncThunk(
  'companyAnalysis/ownershipAndGroup/downloadBranch',
  async (params) => {
    try {
      const res = await OwnershipAndGroupService.downloadBranch(params)
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)

export const downloadSubsidiary = createAsyncThunk(
  'companyAnalysis/ownershipAndGroup/downloadSubsidiary',
  async (params) => {
    try {
      const res = await OwnershipAndGroupService.downloadSubsidiary(params)
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)

export const downloadAssociatedCompany = createAsyncThunk(
  'companyAnalysis/ownershipAndGroup/downloadAssociatedCompany',
  async (params) => {
    try {
      const res = await OwnershipAndGroupService.downloadAssociatedCompany(
        params,
      )
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)

export const downloadRelatedCompany = createAsyncThunk(
  'companyAnalysis/ownershipAndGroup/downloadRelatedCompany',
  async (params) => {
    try {
      const res = await OwnershipAndGroupService.downloadRelatedCompany(params)
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)

export const getOwnershipTypes = createAsyncThunk(
  'companyAnalysis/ownershipAndGroup/getOwnershipTypes',
  async (params, { rejectWithValue }) => {
    try {
      const res = await CategoryService.getOwnershipTypes(params)
      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)
